import styles from '@/admin/components/AdminPagination.module.scss';

type AdminPaginationProps = {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
};

export const AdminPagination = ({ page, pageSize, total, onPageChange }: AdminPaginationProps) => {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  return (
    <div className={styles.wrapper}>
      <span className={styles.info}>
        Page {page} of {totalPages} · {total} total
      </span>
      <div className={styles.controls}>
        <button
          type="button"
          className={styles.button}
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
        >
          Previous
        </button>
        <button
          type="button"
          className={styles.button}
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};
